module.exports = __webpack_public_path__ + "img/bianYaQi1.6a525ac3.png";